import SparkMD5 from 'spark-md5';
import type {
  CollapsibleGraphGroup,
  YGraphState,
  GroupHeaderLayout,
} from '@ardoq/graph';
import type { INode } from '@ardoq/yfiles';
import { INVISIBLE_SEPARATOR } from './consts';
import { layoutGroupHeader } from 'tabview/graphComponent/groupHeader/layoutGroupHeader';

const hashHeaderLayout = (node: INode) => {
  const {
    labels,
    layout: { width: nodeWidth },
  } = node;
  const text = labels
    .map(({ text }) => text)
    .toArray()
    .join(INVISIBLE_SEPARATOR);
  return SparkMD5.hash(`${Math.floor(nodeWidth)}${text}`);
};

const ensureHeaderLayout = (
  node: INode,
  groupHeaders: YGraphState['groupHeaders']
) => {
  const { tag } = node;
  const { id } = tag as CollapsibleGraphGroup;
  const newHash = hashHeaderLayout(node);
  let header = groupHeaders.get(id);
  let layout: GroupHeaderLayout | null = null;
  if (!header) {
    layout = layoutGroupHeader(node);
    if (!layout) {
      return null;
    }
    header = [newHash, layout];
    groupHeaders.set(id, header);
  }
  const [oldHash, oldLayout] = header;
  if (oldHash === newHash) {
    layout = oldLayout;
  } else {
    layout = layoutGroupHeader(node);
    if (!layout) {
      return null;
    }
    header[0] = newHash;
    header[1] = layout;
  }
  return layout;
};

export { ensureHeaderLayout };
